enum SORT_ORDER {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export { SORT_ORDER }
